module.exports = require('./dist/feathers');
